import { scenarioPreset } from './lightingData.js';
import { localDateTime, resolveLocalTime } from './solar.js';
import { buildingVisibility, visibilityAtLevel } from './buildingVisibility.js';
import { ptInPoly } from './geometry.js';

// Defaults are starting assumptions for new objects; saved settings are never reset.
export function guidedLightingScenario(kind, id, environment, now = new Date().toISOString()) {
  const date = localDateTime(now, environment.timeZone).slice(0, 10);
  const timestamp = resolveLocalTime(`${date}T${kind === 'day' ? '12:00' : kind === 'dusk' ? '18:00' : '22:00'}`, environment.timeZone);
  const scenario = scenarioPreset(kind, id, timestamp);
  if (kind === 'dusk') scenario.name = 'Evening';
  return scenario;
}

export const exampleLight = id => ({ id, name: 'Example downlight', kind: 'cone', lumens: 1500, beam: 90, size: .1, source: 'Avisera Planner example — estimated output and uniform beam; replace with the actual light specifications.' });

export function defaultLightHeight(S, point) {
  const walls = visibilityAtLevel(buildingVisibility(S), S.elevation || 0).walls;
  const ceilings = walls.filter(w => ['roof', 'slab'].includes(w.objectKind) && w.bottom > .3 &&
    ptInPoly(point.x, point.y, w.roofPts) && !w.roofHoles?.some(r => ptInPoly(point.x, point.y, r)));
  return ceilings.length ? Math.max(.05, Math.min(...ceilings.map(w => w.bottom)) - .15) : 3;
}
